import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faLock, faBell, faCog, faCreditCard, faHandPointer, faCamera } from "@fortawesome/free-solid-svg-icons";
import {Tab, NotificationTab, AssignUserTab, PaymentAndPlanTab, NotiSettingsTab, AccountSecurityTab, PersonalInfoTab} from  '../components'
import {Fragment, useRef, useState} from "react";
import {CenteredModal, DropzoneFile} from '~/components';
import ProfileAPI from '~/api/profileApi';
import Cropper from "react-cropper";
import {useAssetsImage} from '~/pages/context/AssetsImageContext';
import {useUserAvatar} from '~/pages/context/UserAvatarContext';

const listTabs = [
    {icon : faUser, tabId : "tab-personal-info", tabTitle : "Personal Info", disabled: false},
    {icon : faLock, tabId : "tab-account-security", tabTitle : "Account Security", disabled: false},
    {icon : faBell, tabId : "tab-notification", tabTitle : "Notification", disabled: false},
    {icon : faCog, tabId : "tab-notification-setting", tabTitle : "Notification Settings", disabled: false},
    {icon : faCreditCard, tabId : "tab-plan-payment", tabTitle : "Plan & Payment", disabled: true},
    {icon : faHandPointer, tabId : "tab-assign-user", tabTitle : "Assign User", disabled: true},
]
function ProfileSetting(){
    const [activeTab, setActiveTab] = useState(listTabs[0].tabId);
    const [showUploadModal, setShowUploadModal ] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");

    const { userAvatar, updateAvatar } = useUserAvatar();
    const {getImageUrlById} = useAssetsImage();
    const emptyAvatar = getImageUrlById(63);
    const cropperRef = useRef(null);
    const renderTab = () => {
        switch (activeTab) {
            case listTabs[0].tabId: return <PersonalInfoTab title='Personal Information'/>;
            case listTabs[1].tabId: return <AccountSecurityTab title='Account Security'/>;
            case listTabs[2].tabId: return <NotificationTab title='Notification'/>;
            case listTabs[3].tabId: return <NotiSettingsTab title='Notification Settings'/>;
            case listTabs[4].tabId: return <PaymentAndPlanTab title='Plan And Payment'/>;
            case listTabs[5].tabId: return <AssignUserTab title='Assigned User'/>;
            default: return null;
        }
    };

    const handleConfirmUpload = () => {
        setErrorMessage("");
        if(!selectedFile){
            setErrorMessage("Image is required.");
            return;
        }
        if (!cropperRef.current) return;
        cropperRef.current.cropper.getCroppedCanvas().toBlob((blob) => {
            const formData = new FormData();
            formData.append("file", blob, "avatar.jpg");
            ProfileAPI.updUserAvatar(formData)
                .then(res => {
                    setSelectedFile(null);
                    setImagePreview(null);
                    updateAvatar();
                })
                .catch(err => {
                    
                })
                .finally(() => {
                    setShowUploadModal(false);
                })
        }, "image/jpeg");
    }

    const onCloseUploadModal = () => {
        setShowUploadModal(false);
        setSelectedFile(null);
        setImagePreview(null);
        setErrorMessage("");
    }

    const handleFileSelect = (file) => {
        if (!file) return;
        const validTypes = ["image/jpeg", "image/png", "image/jpg"];
        const maxSizeMB = 2;
        if (file.file.size > maxSizeMB * 1024 * 1024) {
            setErrorMessage("File must be smaller than 2MB.");
            return;
        }
        if(!validTypes.includes(file.file.type)){
            setErrorMessage("Only jpeg, png, jpg files are allowed.");
            return;
        }
        setSelectedFile(file.file);
        setImagePreview(file.preview);
    };


    return (
        <Fragment>
            <div className="mb-9">
                <div className="row g-6">
                    <div className="col-12 col-xl-4">
                        <div className="card mb-5">
                            <div className="card-header hover-actions-trigger position-relative mb-6">
                                <div className="bg-holder rounded-top">
                                    <input className="d-none" id="upload-settings-cover-image" type="file"/>
                                    <div className="hover-actions end-0 bottom-0 pe-1 pb-2 text-white dark__text-gray-1100">
                                        <FontAwesomeIcon icon={faCamera} className='me-2' />
                                    </div>
                                </div>
                                <label className="avatar avatar-4xl feed-avatar-profile cursor-pointer">
                                    {
                                        userAvatar.AvatarUrl &&
                                        <img onClick={() => setShowUploadModal(true)} className="rounded-circle img-thumbnail shadow-sm border-0" src={userAvatar.AvatarUrl ? userAvatar.AvatarUrl : emptyAvatar} width="200" alt=""/>
                                    }
                                </label>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="d-flex flex-wrap mb-1 align-items-center">
                                            <h3 className="me-2">{userAvatar.UserName}</h3>
                                        </div>
                                        <span className="fs-9 fw-bold">{userAvatar.Email}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-xl-8">
                        <div className='col-xl-12 row button-tab'>
                            {
                                listTabs.map((tab, index) => {
                                    return (
                                        <div key={index} className='col'>
                                            <Tab disabled={tab.disabled} icon={tab.icon} tabId={tab.tabId} tabTitle={tab.tabTitle} isActive={activeTab === tab.tabId}
                                            onClick={() => {setActiveTab(tab.tabId)}}/>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className="mb-4 mt-4">
                            {renderTab()}
                        </div>
                    </div>
                </div>
            </div>
            <CenteredModal show={showUploadModal}
                           onClose={onCloseUploadModal}
                           confirmText="Upload Avatar"
                           disabledConfirmBtn={false}
                           title="Upload Avatar"
                           onConfirm={handleConfirmUpload}
            >
                <div className="mb-3">
                    {!imagePreview && (
                        <Fragment>
                            <DropzoneFile
                                label=""
                                name="file"
                                selectedFile={selectedFile}
                                setSelectedFile={handleFileSelect}
                                disabled={false}
                                showPreview={false}
                            />
                            {errorMessage && <span className="fs-9 fw-bold text-danger"> {errorMessage} </span>}
                        </Fragment>
                    )}
                    {imagePreview && (
                        <div>
                            <Cropper
                                src={imagePreview}
                                initialAspectRatio={1}
                                guides={true}
                                viewMode={1}
                                background={false}
                                responsive={true}
                                autoCropArea={1}
                                checkOrientation={false}
                                ref={cropperRef}
                            />
                        </div>
                    )}
                </div>
            </CenteredModal>
        </Fragment>
    )
}
export default ProfileSetting;